/* eslint-disable import/no-unassigned-import, @typescript-eslint/no-non-null-assertion */
import { App } from './App';
import './main.css';
import { createRoot } from 'react-dom/client';

createRoot(document.querySelector('#root')!).render(<App />);
